import React, { ForwardedRef, ReactElement } from "react";
import { ObjectWithStringSignature } from "./componentTypes";
import { Plan2PlateInput, Plan2PlateInputProps } from "./Plan2PlateInput";

type StringKeys<T> = keyof { [K in keyof T]: T[K] extends string ? K : never };

export type StringInputProps<
  T extends ObjectWithStringSignature,
  K extends StringKeys<T> & string,
> = Omit<
  Plan2PlateInputProps<T, K, string>,
  "valueConverter" | "inputType" | "leftAddon" | "leftAddonLabel"
> & {
  fieldDescription?: string;
  dataCy?: string;
};
const StringInputInternal = <
  T extends ObjectWithStringSignature,
  K extends StringKeys<T> & string,
>(
  props: StringInputProps<T, K>,
  ref: ForwardedRef<HTMLInputElement>,
): ReactElement => (
  <Plan2PlateInput
    {...props}
    ref={ref}
    dataCy={props.dataCy}
    inputType="string"
    valueConverter={(e) => e}
    leftAddonLabel={props.fieldDescription}
    placeholder={props.placeholder || props.fieldDescription}
  />
);

export const StringInput = React.forwardRef(StringInputInternal) as <
  T extends ObjectWithStringSignature,
  K extends StringKeys<T> & string,
>(
  props: StringInputProps<T, K> & { ref?: React.Ref<HTMLInputElement> },
) => ReactElement;
